/**
 * My Incentives: help for the award breakdown (the shares, the earned and final award, and one
 * line per reduction type). Wording from the 2026 Variable Compensation plan, generic rules only
 * (DECISIONS 2026-10-15). Longer than column help on purpose: each is the plan's own rule. Each
 * reduction type has its own entry so its wording can be changed in one place.
 */
/** My Incentives: the award breakdown's share, earned and final lines. */
export const INCENTIVE_AWARD_HELP = {
  split:
    "Set by role: Officers 60/40, Leadership 50/50, Managers 40/60, Individual contributors 30/70.",
  earned: "Company + individual: the sum of Awarded.",
  final: "Earned award × (1 − total reductions), never below 0.",
} as const;

/**
 * My Incentives: one line per reduction, by type. Each in its own entry so the plan's wording
 * can be changed in one place.
 */
export const INCENTIVE_PENALTY_HELP = {
  profitSafeguard:
    "Nymbl must finish the year with at least 1% net profit after variable comp. If full payouts would drop profit below that, everyone's payout is reduced by the same percentage.",
  utilization:
    "Not pass/fail. Below the 87% target, your award is reduced by (target − actual) ÷ target. Up to 10 logged sick days don't count against you.",
  lateTimeEntry:
    "First 5 late submissions in a year are free. Each one after that takes 1% off your award, cumulative (6th = 1%, 7th = 2%, 8th = 3%).",
  other: "A reduction to your award.",
} as const;

/** My Incentives: the Late submissions tile. */
export const INCENTIVE_LATE_TILE_HELP =
  "First 5 late sign-offs a year are free; each after that takes 1% off." as const;
